import Store from '@/store'
import Layout from '@/views/layout/Index'
import JSEncrypt from 'jsencrypt/bin/jsencrypt'
// 密钥对生成 http://web.chacuo.net/netrsakeypair
const publicKey = 'MFwwDQYJKoZIhvcNAQEBBQADSwAwSAJBANL378k3RiZHWx5AfJqdH9xRNBmD9wGD\n' +
  '2iRe41HdTNF8RUhNnHit5NpMNtGL0NPTSSpPjjI1kJfVorRvaQerUgkCAwEAAQ=='
const privateKey = 'MIIBUwIBADANBgkqhkiG9w0BAQEFAASCAT0wggE5AgEAAkEA0vfvyTdGJkdbHkB8\n' +
  'mp0f3FE0GYP3AYPaJF7jUd1M0XxFSE2ceK3k2kw20YvQ09NJKk+OMjWQl9WitG9p\n' +
  'B6tSCQIDAQABAkA2SimBrWC2/wvauBuYqjCFwLvYiRYqZKThUS3MZlebXJiLB+Ue\n' +
  '/gUifAAKIg1avttUZsHBHrop4qfJCwAI0+YRAiEA+W3NK/RaXtnRqmoUUkb59zsZ\n' +
  'UBLpvZgQPfj1MhyHDz0CIQDYhsAhPJ3mgS64NbUZmGWuuNKp5coY2GIj/zYDMJp6\n' +
  'vQIgUueLFXv/eZ1ekgz2Oi67MNCk5jeTF2BurZqNLR3MSmUCIFT3Q6uHMtsB9Eha\n' +
  '4u7hS31tj1UWE+D+ADzp59MGnoftAiBeHT7gDMuqeJHPL4b+kC+gzV4FGTfhR9q3\n' +
  'tTbklZkD2A=='
// 加密
export function encrypt (txt) {
  const encryptor = new JSEncrypt()
  encryptor.setPublicKey(publicKey) // 设置公钥
  return encryptor.encrypt(txt) // 对需要加密的数据进行加密
}
// 解密
export function decrypt (txt) {
  const encryptor = new JSEncrypt()
  encryptor.setPrivateKey(privateKey)
  return encryptor.decrypt(txt) // 对需要加密的数据进行解密
}
// 遍历后台传来的路由字符串，转换为组件对象
// TODO: 后端菜单配置可稳定保存并加载 componentPath 后，删除此路由兼容映射。
const STANDALONE_PAGE_MAP = {
  '/pushUpdate': { componentName: 'PushUpdate', componentPath: '/project/PushUpdate' },
  '/readme': { componentName: 'ReadmeManagement', componentPath: '/operation/Readme' }
}
export const filterAsyncRouter = (asyncRouterMap, isTop = true) => {
  return asyncRouterMap.filter(route => {
    if (STANDALONE_PAGE_MAP[route.href]) {
      route.componentName = STANDALONE_PAGE_MAP[route.href].componentName
      route.componentPath = STANDALONE_PAGE_MAP[route.href].componentPath
    }
    route.name = route.componentName
    route.path = route.href
    route.meta = {
      iconUrl: route.icon,
      id: route.id,
      title: route.title
    }
    if (!route.componentPath) {
      route.component = Layout
    } else {
      route.component = loadView(route.componentPath)
    }
    if (route.type === 1) {
      delete route.children
    }
    if (route.children !== null && route.children && route.children.length && route.type !== 2) {
      route.children = filterAsyncRouter(route.children, false)
    }
    // 顶级独立页面（有页面组件但没有子菜单）：包一层 Layout，自身作为唯一子路由，侧边菜单直接可点击
    if (isTop && route.componentPath && !(route.children && route.children.length)) {
      const child = { ...route }
      // vue-router 会忽略与父路由同 path 的子路由记录，子路由改用空 path 作为父路由的默认子页面
      child.path = ''
      route.name = undefined
      // 面包屑标题取子路由，父路由不再保留 title，避免重复
      route.meta = { iconUrl: route.icon, id: route.id }
      route.component = Layout
      route.children = [child]
    }
    return true
  })
}
// 路由懒加载
export const loadView = (view) => {
  return (resolve) => require([`@/views${view}`], resolve)
}
/**
 * 是否显示按钮
 * @param {String}btnName 按钮名称
 */
export const showBtn = (btnName) => {
  let btnAuthArr = []
  for (const item of Store.state.menu) {
    for (const _item of item.children || []) {
      if (_item.path === window.location.pathname) {
        _item.children = _item.children || []
        btnAuthArr = _item.children.map(btn => btn.meta.title)
        return btnAuthArr.includes(btnName)
      }
    }
  }
  return false
}
/**
 * 英文括号转中文括号
 * @param {String}text
 */
export const filterStr = (text) => {
  let newMsg = ''
  const reg1 = new RegExp('\\(', 'g')
  const reg2 = new RegExp('\\)', 'g')
  newMsg = text.replace(reg1, '（').replace(reg2, '）')
  return newMsg
}
/**
 * 对象数组去重，默认id去重
 * @param arr {Array}
 * @param type {String}
 */
export const ObjArrSet = (arr, type = 'id') => {
  const res = new Map();
  return arr.filter((item) => !res.has(item[type]) && res.set(item[type], 1));
}
